<template>
  <px-custom-dialog transition="fadet"
                    width="550"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Editando fornecedor
    </template>
    <template>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="250"
            label="Nome"
            class="rounded-tag-small"
            v-model="fornecedor.nome"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="250"
            label="Código interno"
            class="rounded-tag-small"
            v-model="fornecedor.codigoInterno"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12">
          <v-switch dense
                    v-model="fornecedor.transportadora"
                    @change="onChangeFlagTransportadora"
                    class="pa-0 mt-2 mr-2"
                    label="É transportadora?"
                    color="primary"
          />
        </v-col>
      </v-row>
      <v-row dense v-if="fornecedor.transportadora">
        <v-col cols="12" sm="12">
          <v-text-field dense
                        outlined
                        hide-details
                        label="Código interno da transportadora"
                        class="rounded-tag-small"
                        v-model="fornecedor.codigoTransportadora"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            label="Site"
            class="rounded-tag-small"
            :error="$v.fornecedor.site.$error"
            @blur="$v.fornecedor.site.$touch()"
            v-model="fornecedor.site"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            label="Observações internas"
            counter="1500"
            rows="3"
            class="rounded-tag-small"
            v-model="fornecedor.observacoesInternas"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12">
          <px-switch-tooltip
            v-model="fornecedor.permiteEdicaoCotacao"
            label="Editar cotações"
            tooltip="Habilita a edição das respostas submetidas por este fornecedor no<br>
              processo de cotação, desde que não possua negociação em aberto."/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="fornecedor.ativo"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loading"
             :disabled="$v.$invalid"
             @click="save">
        Salvar
      </v-btn>
      <v-btn text class="normal-btn-text" @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { email, url } from 'vuelidate/lib/validators';
import GestaoFornecedorService from '../../gestao-fornecedor-service';

export default {
  props: {
    currentFornecedor: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      fornecedor: {
        codigoInterno: null,
        nome: null,
        observacoesInternas: null,
        site: null,
        ativo: true,
        permiteEdicaoCotacao: true,
        transportadora: false,
        codigoTransportadora: null,
      },
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    initialState() {
      this.fornecedor.nome = this.currentFornecedor.nome;
      this.fornecedor.observacoesInternas = this.currentFornecedor.observacoesInternas;
      this.fornecedor.codigoInterno = this.currentFornecedor.codigoInterno;
      this.fornecedor.site = this.currentFornecedor.fornecedor.site;
      this.fornecedor.ativo = this.currentFornecedor.ativo;
      this.fornecedor.permiteEdicaoCotacao = this.currentFornecedor.permiteEdicaoCotacao;
      this.fornecedor.transportadora = this.currentFornecedor.transportadora;
      this.fornecedor.codigoTransportadora = this.currentFornecedor.codigoTransportadora;
    },
    buildPayload() {
      const fornecedor = { ...this.fornecedor };
      return {
        ...fornecedor,
        fornecedor: {
          ...this.currentFornecedor.fornecedor,
          site: fornecedor.site,
        },
        site: undefined,
      };
    },
    save() {
      this.loading = true;
      GestaoFornecedorService.update(this.currentFornecedor.id, this.buildPayload())
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Fornecedor atualizado', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangeFlagTransportadora(newValue) {
      if (!newValue) {
        this.fornecedor.codigoTransportadora = null;
      }
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.initialState();
    },
  },
  validations: {
    fornecedor: {
      email: {
        email,
      },
      site: {
        url,
      },
    },
  },
};
</script>
